import { render } from "./OverlayColorPicker.vue?vue&type=template&id=60778e62&scoped=true"
import script from "./OverlayColorPicker.vue?vue&type=script&lang=js"
export * from "./OverlayColorPicker.vue?vue&type=script&lang=js"

import "./OverlayColorPicker.vue?vue&type=style&index=0&id=60778e62&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60778e62"]])

export default __exports__